export const gallery = [
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265689/T_P%20Site/Gallery/2_kpivea.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659267560/T_P%20Site/Gallery/photo_2022-07-31_17-08-38_ncpsmd.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265619/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.21.16_AM_tuupr7.jpg",
    width: 4,
    height: 3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618465/WhatsApp_Image_2024-07-10_at_16.59.10_kjq1bd.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618440/WhatsApp_Image_2024-07-10_at_15.57.15_as3doy.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618471/WhatsApp_Image_2024-07-10_at_16.59.14_g7pgri.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618387/WhatsApp_Image_2024-07-10_at_15.53.21_fthlwy.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618500/WhatsApp_Image_2024-07-10_at_16.59.20_phrkyj.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618487/WhatsApp_Image_2024-07-10_at_16.59.19_fgxfjc.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618586/WhatsApp_Image_2024-07-10_at_17.01.40_jmpsyb.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618571/WhatsApp_Image_2024-07-10_at_16.59.28_jqpfcp.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618555/WhatsApp_Image_2024-07-10_at_16.59.26_pdnsmq.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618538/WhatsApp_Image_2024-07-10_at_16.59.25_qejwjf.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618526/WhatsApp_Image_2024-07-10_at_16.59.23_pmzh0o.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618411/WhatsApp_Image_2024-07-10_at_15.55.34_ym1bac.jpg",
    width:4,
    height:3,
  },
  {
    src:"https://res.cloudinary.com/da9ygbhjv/image/upload/v1720618514/WhatsApp_Image_2024-07-10_at_16.59.21_woj9ms.jpg",
    width:4,
    height:3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265618/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.21.16_AM_1_pnyqgn.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265613/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.21.16_AM_2_pidxv6.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265611/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.35.53_AM_qhszor.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265610/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.21.17_AM_fynhft.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265609/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.32.56_AM_bhjzwo.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659267560/T_P%20Site/Gallery/photo_2022-07-31_17-08-48_rukeux.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265608/T_P%20Site/Gallery/WhatsApp_Image_2022-04-09_at_3.35.54_AM_vl7pea.jpg",
    width: 4,
    height: 3,
  },
  
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659265921/T_P%20Site/Gallery/IMG_3384_n6uchc.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266101/T_P%20Site/Gallery/IMG_3498_svwdra.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266292/T_P%20Site/Gallery/photo_2022-07-31_16-45-06_vnq0hi.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266295/T_P%20Site/Gallery/Screenshot_79_v5h1cj.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266293/T_P%20Site/Gallery/Screenshot_69_tjy35a.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659267559/T_P%20Site/Gallery/photo_2022-07-31_17-08-44_nlinlv.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266292/T_P%20Site/Gallery/photo_2022-07-31_16-44-52_fplrx8.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266144/T_P%20Site/Gallery/Screenshot_291_r57op5.png",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659267560/T_P%20Site/Gallery/photo_2022-07-31_17-08-50_jebd9b.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266139/T_P%20Site/Gallery/IMG_4510_pb8bwn.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266136/T_P%20Site/Gallery/IMG_4610_mnnccl.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266143/T_P%20Site/Gallery/Screenshot_240_ym6wth.png",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659267560/T_P%20Site/Gallery/photo_2022-07-31_17-08-41_xnffk2.jpg",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/daxilgrvn/image/upload/v1659266077/T_P%20Site/Gallery/IMG_3431_bprbri.jpg",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/dnrlpjsvu/image/upload/f_auto,q_auto/l4popytuguanuzgf0mcm",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/dnrlpjsvu/image/upload/f_auto,q_auto/htgtigqrdgekuvi8va1x",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/dnrlpjsvu/image/upload/f_auto,q_auto/WhatsApp_Image_2023-06-18_at_12.10.40_AM_cubpzz",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/dnrlpjsvu/image/upload/v1687169765/arsh_goyal_1_wtvc3h.jpg",
    width: 4,
    height: 3,
  },

  {
    src: "https://res.cloudinary.com/dnrlpjsvu/image/upload/v1687169765/arsh_goyal_jzbq2n.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/dkddubkcn/image/upload/v1697268558/3_x2isq6.jpg",
    width: 4,
    height: 3,
  },
  {
    src: "https://res.cloudinary.com/dkddubkcn/image/upload/v1697268603/2_kiwpyp.jpg",
    width: 4,
    height: 3,
  }
];
